import Constant from '../lib/constant';
import axiosClient from './axiosClient';

const url = Constant.apiUrl + '/sections';
const sectionApiV2 = {
	get: (params) => {
		return axiosClient.get(url + '/admin', { params });
	},
	update: (id, body) => {
		return axiosClient.put(url + `/${id}`, body);
	},
	create: (body) => {
		return axiosClient.post(url, body);
	},
	getById: (id) => {
		return axiosClient.get(url + `/admin/${id}`);
	},
	delete: (id) => {
		return axiosClient.delete(url + `/${id}`);
	},
};
export default sectionApiV2;
